module.exports = __webpack_public_path__ + "img/authorityLogo4.11ad21db.png";